// Logo dédié à l'application Admin AutoQuote.
// Reprend le logo AutoQuote (carré bleu rotaté, lettre A) et y ajoute un
// badge "admin" (engrenage) dans le coin pour distinguer l'app de pilotage
// du produit client.

interface AdminLogoProps {
  /** Taille du carré principal en pixels */
  size?: number;
  /** Affiche le wordmark "AutoQuote · Admin" à droite du picto */
  showWordmark?: boolean;
  /** Classe additionnelle sur le wrapper */
  className?: string;
}

export function AdminLogo({ size = 40, showWordmark = false, className = '' }: AdminLogoProps) {
  return (
    <div className={`inline-flex items-center gap-3 ${className}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="AutoQuote Admin"
      >
        <defs>
          <linearGradient id="adminLogoGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#0066FF" />
            <stop offset="100%" stopColor="#00AAFF" />
          </linearGradient>
          <linearGradient id="adminBadgeGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#0A1F44" />
            <stop offset="100%" stopColor="#1E3A8A" />
          </linearGradient>
        </defs>

        {/* Carré principal rotaté avec la lettre A (identique au logo AutoQuote) */}
        <rect
          x="10"
          y="10"
          width="80"
          height="80"
          rx="20"
          fill="url(#adminLogoGrad)"
          transform="rotate(-15, 50, 50)"
        />
        <text
          x="50"
          y="67"
          fontSize="48"
          fontWeight="bold"
          fill="white"
          textAnchor="middle"
          fontFamily="system-ui, -apple-system, sans-serif"
        >
          A
        </text>

        {/* Badge admin : disque foncé avec un engrenage stylisé en bas-droite */}
        <g transform="translate(72, 72)">
          <circle r="20" fill="url(#adminBadgeGrad)" />
          <circle r="20" fill="none" stroke="white" strokeWidth="2" opacity="0.9" />
          {/* Engrenage simplifié */}
          <g fill="white">
            {/* Dents (8) */}
            {Array.from({ length: 8 }).map((_, i) => {
              const angle = (i * 360) / 8;
              return (
                <rect
                  key={i}
                  x="-1.6"
                  y="-12"
                  width="3.2"
                  height="4.5"
                  rx="0.6"
                  transform={`rotate(${angle})`}
                />
              );
            })}
            <circle r="7.5" />
            <circle r="3" fill="url(#adminBadgeGrad)" />
          </g>
        </g>
      </svg>

      {showWordmark && (
        <div className="flex flex-col leading-tight">
          <span className="font-bold text-lg bg-gradient-to-r from-[#0066FF] to-[#00AAFF] bg-clip-text text-transparent">
            AutoQuote
          </span>
          <span className="text-[10px] font-semibold tracking-[0.18em] uppercase text-neutral-500">
            Admin
          </span>
        </div>
      )}
    </div>
  );
}

export default AdminLogo;
